var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/documenttext1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.25 13.75V20.625C30.25 27.5 27.5 30.25 20.625 30.25H12.375C5.5 30.25 2.75 27.5 2.75 20.625V12.375C2.75 5.5 5.5 2.75 12.375 2.75H19.25",
    stroke: "#F8F6F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.625 17.875H17.875M9.625 23.375H15.125M30.25 13.75H24.75C20.625 13.75 19.25 12.375 19.25 8.25V2.75L30.25 13.75Z",
    stroke: "#F8F6F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/documentText.c5164e8659fb5ac7592be795b1479ac4.svg";
export { ForwardRef as ReactComponent };